import { render, staticRenderFns } from "./atendimento.vue?vue&type=template&id=801cba22&scoped=true"
import script from "./atendimento.vue?vue&type=script&lang=js"
export * from "./atendimento.vue?vue&type=script&lang=js"
import style0 from "./atendimento.vue?vue&type=style&index=0&id=801cba22&prod&scoped=true&lang=css"
import style1 from "./atendimento.vue?vue&type=style&index=1&id=801cba22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801cba22",
  null
  
)

export default component.exports